import moment from "moment";

class FilterGenerator {
  private _query = "";

  private generateFilter(logical, field, value, type?, subField?) {
    let filter = "";

    if (value || value === false) {
      switch (type) {
        case "dateRange":
          if (value.from && value.to) {
            filter = `(${field} ge DateTime'${moment(value.from)
              .startOf("day")
              .format("YYYY-MM-DDTHH:mm:ss")}'
              and ${field} le DateTime'${moment(value.to)
              .endOf("day")
              .format("YYYY-MM-DDTHH:mm:ss")}')`;
          } else if (value.from) {
            filter = `${field} ge DateTime'${moment(value.from)
              .startOf("day")
              .format("YYYY-MM-DDTHH:mm:ss")}'`;
          } else if (value.to) {
            filter = `${field} le DateTime'${moment(value.to)
              .endOf("day")
              .format("YYYY-MM-DDTHH:mm:ss")}'`;
          }
          break;
        case "numberRange":
          if (value.from && value.to) {
            filter = `(${field} ge ${value.from} and ${field} le ${value.to})`;
          } else if (value.from) {
            filter = `${field} ge ${value.from}`;
          } else if (value.to) {
            filter = `${field} le ${value.to}`;
          }
          break;
        case "number":
          filter = `${field} eq ${value}`;
          break;
        case "boolean":
          filter = `${field} eq ${value}`;
          break;
        case "array":
          filter = `${field}/any(l:indexof(tolower(l/${subField}), '${value.toLowerCase()}') gt -1)`;
          break;
        case "select":
          filter = `${field} eq '${value.value}'`;
          break;
        case "date":
          filter = `${field} eq DateTime'${moment(value).format(
            "YYYY-MM-DD"
          )}'`;
          break;
        case "string":
          filter = `${field} eq '${value}'`;
          break;
        default:
          filter = `indexof(tolower(${field}), '${value.toLowerCase()}') gt -1`;
      }
    }

    this._query +=
      logical && (value || value === false) ? ` ${logical} ${filter}` : filter;
  }

  public addText(text) {
    this._query += text;
  }

  public and(field, value, type?, subField?) {
    const logical = this._query && "and";

    this.generateFilter(logical, field, value, type, subField);
  }

  public or(field, value, type?, subField?) {
    const logical = this._query && "or";

    this.generateFilter(logical, field, value, type, subField);
  }

  public without(field, value, type?, subField?) {
    this.generateFilter(null, field, value, type, subField);
  }

  public get query() {
    return this._query;
  }
}

export default FilterGenerator;
